export const Types = {
    GET_ALL_LIST_FOR_GENERAL_TABLE: "GET_ALL_LIST_FOR_GENERAL_TABLE",
    SET_ALL_LIST_FOR_GENERAL_TABLE: "SET_ALL_LIST_FOR_GENERAL_TABLE",
    RESET_ALL_LIST_OF_GENERAL_TABLE: "RESET_ALL_LIST_OF_GENERAL_TABLE",
    UPDATE_RECORD_OF_LIST: "UPDATE_RECORD_OF_LIST",
    UPDATE_RECORD_OF_LIST_RESPONSE: "UPDATE_RECORD_OF_LIST_RESPONSE",
    DELETE_RECORD_OF_LIST: "DELETE_RECORD_OF_LIST",
    ADD_RECORD_OF_LIST: "ADD_RECORD_OF_LIST",
    GET_PLANTS_FOR_GENERAL_TABLE: "GET_PLANTS_FOR_GENERAL_TABLE",
    SET_PLANTS_FOR_GENERAL_TABLE: "SET_PLANTS_FOR_GENERAL_TABLE",
    GET_ITEMGROUPLIST_FOR_GENERAL_TABLE: "GET_ITEMGROUPLIST_FOR_GENERAL_TABLE",
    SET_ITEMGROUPLIST_FOR_GENERAL_TABLE: "SET_ITEMGROUPLIST_FOR_GENERAL_TABLE",
    GET_MAIL_GROUPS_FOR_GENERAL_TABLE: "GET_MAIL_GROUPS_FOR_GENERAL_TABLE",
    SET_MAIL_GROUPS_FOR_GENERAL_TABLE: "SET_MAIL_GROUPS_FOR_GENERAL_TABLE",
    GET_MAIL_PERIODS_FOR_GENERAL_TABLE: "GET_MAIL_PERIODS_FOR_GENERAL_TABLE",
    SET_MAIL_PERIODS_FOR_GENERAL_TABLE: "SET_MAIL_PERIODS_FOR_GENERAL_TABLE",
    RESET_PLANTS_FOR_GENERAL_TABLE: "RESET_PLANTS_FOR_GENERAL_TABLE",
    GET_BREAK_DOWN_PLACE_BY_ID_FOR_GENERAL_TABLE: "GET_BREAK_DOWN_PLACE_BY_ID_FOR_GENERAL_TABLE",
    SET_BREAK_DOWN_PLACE_BY_ID_FOR_GENERAL_TABLE: "SET_BREAK_DOWN_PLACE_BY_ID_FOR_GENERAL_TABLE",
    RESET_BREAK_DOWN_PLACE_BY_ID_FOR_GENERAL_TABLE: "RESET_BREAK_DOWN_PLACE_BY_ID_FOR_GENERAL_TABLE",
    GET_BREAK_DOWN_REASON_GROUPS_FOR_GENERAL_TABLE: "GET_BREAK_DOWN_REASON_GROUPS_FOR_GENERAL_TABLE",
    SET_BREAK_DOWN_REASON_GROUPS_FOR_GENERAL_TABLE: "SET_BREAK_DOWN_REASON_GROUPS_FOR_GENERAL_TABLE",
    RESET_BREAK_DOWN_REASON_GROUPS_FOR_GENERAL_TABLE: "RESET_BREAK_DOWN_REASON_GROUPS_FOR_GENERAL_TABLE",
    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
};

export const getAllList = (payload) => ({
    type: Types.GET_ALL_LIST_FOR_GENERAL_TABLE,
    payload: payload,
});

export const setAllList = (payload) => ({
    type: Types.SET_ALL_LIST_FOR_GENERAL_TABLE,
    payload: payload,
});

export const resetList = () => ({
    type: Types.RESET_ALL_LIST_OF_GENERAL_TABLE,
});

export const updateRecord = (payload) => ({
    type: Types.UPDATE_RECORD_OF_LIST,
    payload: payload,
});

export const setUpdateRecord = (payload) => ({
    type: Types.UPDATE_RECORD_OF_LIST_RESPONSE,
    payload: payload,
});

export const deleteRecord = (payload) => ({
    type: Types.DELETE_RECORD_OF_LIST,
    payload: payload,
});

export const addRecord = (payload) => ({
    type: Types.ADD_RECORD_OF_LIST,
    payload: payload,
});

export const getPlants = () => ({
    type: Types.GET_PLANTS_FOR_GENERAL_TABLE,
});

export const setPlants = (payload) => ({
    type: Types.SET_PLANTS_FOR_GENERAL_TABLE,
    payload: payload,
});

export const getMailGroups = (payload) => ({
    type: Types.GET_MAIL_GROUPS_FOR_GENERAL_TABLE,
    payload: payload,
});

export const setMailGroups = (payload) => ({
    type: Types.SET_MAIL_GROUPS_FOR_GENERAL_TABLE,
    payload: payload,
});

export const getMailPeriods = (payload) => ({
    type: Types.GET_MAIL_PERIODS_FOR_GENERAL_TABLE,
    payload: payload,
});

export const setMailPeriods = (payload) => ({
    type: Types.SET_MAIL_PERIODS_FOR_GENERAL_TABLE,
    payload: payload,
});

export const resetPlants = () => ({
    type: Types.RESET_PLANTS_FOR_GENERAL_TABLE,
});

export const getBreakDownPlaceByGroupId = (payload) => ({
    type: Types.GET_BREAK_DOWN_PLACE_BY_ID_FOR_GENERAL_TABLE,
    payload: payload,
});

export const setBreakDownPlaceByGroupId = (payload) => ({
    type: Types.SET_BREAK_DOWN_PLACE_BY_ID_FOR_GENERAL_TABLE,
    payload: payload,
});

export const resetBreakDownPlaceByGroupId = () => ({
    type: Types.RESET_BREAK_DOWN_PLACE_BY_ID_FOR_GENERAL_TABLE,
});

export const getBreakDownReasonGroups = () => ({
    type: Types.GET_BREAK_DOWN_REASON_GROUPS_FOR_GENERAL_TABLE,
});

export const setBreakDownReasonGroups = (payload) => ({
    type: Types.SET_BREAK_DOWN_REASON_GROUPS_FOR_GENERAL_TABLE,
    payload: payload,
});

export const resetBreakDownReasonGroups = (payload) => ({
    type: Types.RESET_BREAK_DOWN_REASON_GROUPS_FOR_GENERAL_TABLE,
    payload: payload,
});

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});
